import service from '@/api/statistics';
import {loading, handleError} from '@/state/generators/helpers';

export const state = {
    loading: false,
    service: service('admin/statistics'),
    statistics: null,
    errors: {}
};

export const getters = {
    loading: function (state) {
        return !!state.loading;
    },
    statistics: function (state) {
        return state.statistics ? JSON.parse(JSON.stringify(state.statistics)) : null;
    }
};

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean;
    },
    'SET_STATISTICS': function (state, statistics = null) {
        state.statistics = statistics;
    },
    'SET_ERRORS': function (state, errors = {}) {
        state.errors = errors;
    }
};

export const actions = {
    fetch: function ({commit, state}) {
        loading(commit);

        return state.service.fetchStatistics().then(response => {
            commit('SET_STATISTICS', response);
            loading(commit, false);
            return response;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    clearModule: function ({commit}) {
        commit('SET_STATISTICS', null);
        commit('SET_ERRORS', {});
    }
};
